import { useRouter } from 'next/router'
import { useEffect, useContext } from 'react'
import { useAuth } from '.'
import SplashScreen from '../../components/SplashScreen'
import { t } from '../i18n'
import { ModalsContext } from '../modals'
import { labSignInPath } from '../routeHelpers'
import guidelinesModalStyles from '../../components/modals/_guidelinesModal.module.scss'
import welcomeLabModalStyles from '../../components/modals/_welcomeLabModal.module.scss'

export const ProtectRoute = (Component: React.FC, params = null) => {
  return (props) => {
    const { isAuthenticated, isLoading, isMusician, currentUser } = useAuth()
    const router = useRouter()
    const isForbidden = params?.protectFromMusician && isMusician
    const isLabPage = params?.isLabPage
    const isCommunityPage = params?.isCommunityPage
    const hasLabSubscription = currentUser?.labSubscriptionActive
    const isGuidelinesAccepted = !!currentUser?.guidelinesAcceptedAt
    const isWelcomeLabShown = !!currentUser?.welcomeLabShownAt
    const { openModal, closeModal } = useContext(ModalsContext)

    const openSignInModal = () => {
      openModal({
        name: 'SignIn',
        props: {
          onClose: closeModal
        },
        onModalClose: onClose,
        modalTitle: t('Sign In')
      })
    }
    const onClose = () => {
      router.back()
    }

    const openLabSignInModal = () => {
      router.push(labSignInPath(router.asPath))
    }

    const openGuidelinesModal = () => {
      openModal({
        name: 'GuidelinesModal',
        props: {
          onClose: closeModal
        },
        onModalClose: () => {},
        modalTitle: '',
        hideCloseButton: true,
        modifier: guidelinesModalStyles.guidelinesModalModifier
      })
    }

    const openWelcomeLabModal = () => {
      openModal({
        name: 'WelcomeLabModal',
        props: {
          onClose: closeModal
        },
        onModalClose: () => {},
        modalTitle: '',
        hideCloseButton: true,
        disableBackdropClose: true,
        modifier: welcomeLabModalStyles.welcomeLabModalModifier
      })
    }

    useEffect(() => {
      if (!isLoading) {
        if (isLabPage && !hasLabSubscription) {
          openLabSignInModal()
        } else if (
          isCommunityPage &&
          hasLabSubscription &&
          !isGuidelinesAccepted
        ) {
          openGuidelinesModal()
        } else if (isForbidden || (!isAuthenticated && !isCommunityPage)) {
          openSignInModal()
        } else if (
          (isLabPage || isCommunityPage) &&
          isAuthenticated &&
          hasLabSubscription &&
          !isWelcomeLabShown
        ) {
          openWelcomeLabModal()
        }
      }
    }, [
      isLoading,
      isAuthenticated,
      isMusician,
      isLabPage,
      hasLabSubscription,
      isCommunityPage,
      isGuidelinesAccepted,
      isWelcomeLabShown,
      router.asPath
    ])

    if (!isCommunityPage && (isLoading || !isAuthenticated)) {
      return <SplashScreen />
    }

    return <Component {...props} />
  }
}
